import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

const NAMESPACE = 'auth';

export const selectIsAuthenticated = (state) =>
  !isEmpty(get(state, [NAMESPACE, 'tokenInfo']));
export const selectPinCodeVerification = (state) =>
  state?.auth?.deviceDetails || {};
